module.exports = __webpack_public_path__ + "static/media/slideshow-24.a2398e0b.jpeg";